import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    private storage: AngularFireStorage,
  ) { }

  //Obtener URL (ubicación) del archivo en el sistema
  getReferenceOfFile(fileLocation){
    return this.storage.storage.ref().child(fileLocation);
  }
  //Subir archivo 
  upload(file, fileLocation){
    return this.storage.upload(fileLocation,file);
  }
  //Borrar archivo
  delete(fileLocation){
    return this.storage.ref(fileLocation).delete();
  }
  
}

